import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Zap, Lock, Server, ArrowRight } from 'lucide-react';
import { Card } from '../../ui/card';

const iconMap = {
  Brain,
  Zap,
  Lock,
  Server,
};

const SolutionSlide = ({ data }) => {
  return (
    <div className="w-full max-w-6xl mx-auto">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-8"
      >
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">{data.title}</h2>
        <p className="text-xl text-cyan-400 font-medium mb-2">{data.subtitle}</p>
        <p className="text-lg text-slate-400 max-w-2xl mx-auto">{data.description}</p>
      </motion.div>

      {/* Central Visual */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.3 }}
        className="relative flex justify-center mb-8"
      >
        <div className="relative">
          <div className="w-32 h-32 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-3xl flex items-center justify-center shadow-lg shadow-cyan-500/30">
            <Brain className="w-16 h-16 text-white" />
          </div>
          <div className="absolute -inset-4 bg-cyan-500/20 rounded-3xl blur-xl -z-10" />
        </div>
      </motion.div>

      {/* Feature Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {data.features.map((feature, index) => {
          const Icon = iconMap[feature.icon];
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 + index * 0.1 }}
            >
              <Card className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 border-cyan-500/20 p-5 h-full text-center hover:border-cyan-500/40 transition-all hover:-translate-y-1">
                <div className="p-3 bg-cyan-500/10 rounded-xl inline-block mb-3">
                  <Icon className="w-6 h-6 text-cyan-400" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-1">{feature.label}</h3>
                <p className="text-sm text-slate-400">{feature.desc}</p>
              </Card>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default SolutionSlide;
